import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface AdminWorldSummary {
	id: string;
	name: string;
	status: string;
	ownerId: string;
	ownerEmail: string;
	ownerName: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface AdminWorldsListResponse {
	worlds: AdminWorldSummary[];
}

@Injectable({ providedIn: 'root' })
export class AdminWorldsService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<AdminWorldsListResponse> {
		return this.http.get<AdminWorldsListResponse>(`${environment.api.baseUrl}/v1/admin/worlds`);
	}
}
